import React from "react";
import { useLocation } from "react-router-dom";
import AppResponsiveLayout from "./AppResponsiveLayout";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const location = useLocation();

  // 레이아웃이 필요 없는 경로들
  const noLayoutPaths = ["/", "/privacy"];

  // 현재 경로가 레이아웃이 필요 없는 경로인지 확인
  const needsLayout = !noLayoutPaths.includes(location.pathname);

  if (needsLayout) {
    return <AppResponsiveLayout>{children}</AppResponsiveLayout>;
  }

  return <>{children}</>;
};

export default LayoutWrapper;